module.exports = __webpack_public_path__ + "static/media/BLungCancerClinic.6dfad761.png";